import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const stackItems = [{
  name: 'Ebook principal: Volvé a Calmar tu Mente en 21 Días',
  value: '$14999'
}, {
  name: 'Bono 1: Reprogramá tu Mente Ansiosa',
  value: 'GRATIS'
}, {
  name: 'Bono 2: Dormí en Paz',
  value: 'GRATIS'
}, {
  name: 'Bono 3: Ansiedad en Relaciones y Apego',
  value: 'GRATIS'
}, {
  name: 'Bono 4: Calmá tu Cuerpo',
  value: 'GRATIS'
}, {
  name: 'Bono 5: Detox de Estrés y Sobrecarga Mental',
  value: 'GRATIS'
}, {
  name: 'Bono 6: Sistema de Paz en 21 Días',
  value: 'GRATIS'
}];
export function ValueStackSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="checkout" className="py-24 bg-beige-light text-navy relative overflow-hidden" data-id="element-199">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-200"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-201">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-navy" data-id="element-203">
            Todo lo que recibís hoy
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-204"></div>
        </motion.div>

        <motion.div className="bg-white/70 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-gold/20 shadow-2xl" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-205">
          <ul className="space-y-4 mb-10" data-id="element-206">
            {stackItems.map((item, index) => <motion.li key={index} className="flex items-center justify-between py-3 border-b border-navy/10 last:border-0" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + index * 0.1
          }} data-id="element-207">
                <div className="flex items-center gap-3 pr-4" data-id="element-208">
                  <Check size={18} className="text-gold shrink-0" data-id="element-209" />
                  <span className={`${index === 0 ? 'font-medium text-navy' : 'text-slate text-sm md:text-base'} text-[14px] font-[400]`} data-id="element-210">
                    {item.name}
                  </span>
                </div>
                <span className="font-serif shrink-0 text-[16px] font-[900] text-[#A37727]" data-id="element-211">
                  Valor: {item.value}
                </span>
              </motion.li>)}
          </ul>

          <div className="bg-navy rounded-2xl p-6 md:p-8 text-center border border-navy/10" data-id="element-212">
            <p className="text-beige-light/80 mb-2" data-id="element-213">
              Valor total: <span className="line-through" data-id="element-214">$30000</span>
            </p>
            <h3 className="text-3xl md:text-4xl font-serif text-gold mb-8" data-id="element-215">
              Hoy accedés a todo por solo $14999
            </h3>

            <a href="https://menteenpazmethod.com/cart/47650140717207:1" className="btn-shine inline-block w-full sm:w-auto px-10 py-5 bg-gold text-navy-dark rounded-xl font-bold text-lg shadow-[0_0_30px_rgba(201,169,110,0.3)] hover:shadow-[0_0_40px_rgba(201,169,110,0.5)] hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-216">
              QUIERO MI ACCESO AHORA
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}